export default {
    machine_comments: "",
    machine_desc: "",
    machine_nct_expiry: "",
    machine_reg: "",
    machine_status: "Online",
    machine_tax_expiry: "",
    photo_url: "",
    areas: [],
    created_by: "",
    departments: [],
    service_period: "",
    attached_photos:[],
    inspection_records: [],
    service_data: [],
    inspection_template:"",
    last_service_date:"",
    machine_category:"",
    machine_insurance_expiry:"",
    machine_nickname:"",
    thorough_inspection_service_period:""
};
